import { FontSize, LineHeight } from '../../styles/constants';

export interface TypeConfig {
  lineHeight: { lowRes: string; highRes: string };
  size: { lowRes: string; highRes: string };
  marginBottom?: { lowRes: string; highRes: string };
  fontWeight: number;
}

type TypeConfigMap = {
  [key: string]: TypeConfig;
};

export const typeConfig: TypeConfigMap = {
  h1: {
    size: { lowRes: FontSize.HEADING_1_SMALL, highRes: FontSize.HEADING_1 },
    lineHeight: { lowRes: LineHeight.HEADING_1_SMALL, highRes: LineHeight.HEADING_1 },
    fontWeight: 400,
    marginBottom: { lowRes: '24px', highRes: '40px' },
  },
  h2: {
    size: { lowRes: FontSize.HEADING_2_SMALL, highRes: FontSize.HEADING_2 },
    lineHeight: { lowRes: LineHeight.HEADING_2_SMALL, highRes: LineHeight.HEADING_2 },
    fontWeight: 400,
  },
  h3: {
    size: { lowRes: FontSize.HEADING_3_SMALL, highRes: FontSize.HEADING_3 },
    lineHeight: { lowRes: LineHeight.HEADING_3_SMALL, highRes: LineHeight.HEADING_3 },
    fontWeight: 400,
  },
  h4: {
    size: { lowRes: FontSize.HEADING_4_SMALL, highRes: FontSize.HEADING_4 },
    lineHeight: { lowRes: LineHeight.HEADING_4_SMALL, highRes: LineHeight.HEADING_4 },
    fontWeight: 400,
  },
  h5: {
    size: { lowRes: FontSize.HEADING_5_SMALL, highRes: FontSize.HEADING_5 },
    lineHeight: { lowRes: LineHeight.HEADING_5_SMALL, highRes: LineHeight.HEADING_5 },
    fontWeight: 400,
  },
};
